var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('Chrome',{directives:[{name:"closable",rawName:"v-closable",value:({
    exclude: [],
    handler: 'hideModal',
  }),expression:"{\n    exclude: [],\n    handler: 'hideModal',\n  }"}],staticClass:"position-absolute color-picker",on:{"input":_vm.choose},model:{value:(_vm.newColor),callback:function ($$v) {_vm.newColor=$$v},expression:"newColor"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }